'use client';

import type { CSSProperties } from 'react';
import clsx from 'clsx';
import tip1 from '../../images/tip1.png';
import tip2 from '../../images/tip2.png';
import type { BadgeType } from '../types';
import { useTranslations } from 'next-intl';

interface StatusBadgeProps {
  badge: BadgeType;
  width?: number;
  widthImage?: number;
}

export function getBadgeBackgroundStyle(imageUrl: string, width: number, widthImage?: number): CSSProperties {
  return {
    borderStyle: 'solid',
    borderWidth: `0 ${width || 6}px`,
    borderImageSource: `url(${imageUrl})`,
    borderImageSlice: `0 ${widthImage || 6} fill`,
    borderImageRepeat: 'stretch',
  };
}

export default function StatusBadge({ badge, width = 6, widthImage = 6 }: StatusBadgeProps) {
  const t = useTranslations('reward');
  if (!badge) return null;

  const isNew = badge === 'new';
  const backgroundStyle = getBadgeBackgroundStyle(isNew ? tip1.src : tip2.src, width, widthImage);

  return (
    <div
      className={clsx(
        'absolute top-0 right-0 inline-flex h-[17px] min-w-[36px] items-center justify-center px-1 text-[9px] font-bold leading-none text-white',
      )}
      style={backgroundStyle}
    >
      <div className='m-[-5]'>
        {isNew ? 'New' : t('expiringSoon')}
      </div>
    </div>
  );
}
